import { SalesData as ApiSalesData } from "randmar-api-client";
import React from "react";
import { FormattedNumber } from "react-intl";
import { Card } from "randmarcomps";
import { LongMonthName } from "../../components/util/DateTimeUtil";
import SalesTrendingIcon from "../../components/util/SalesTrendingIcon";
import { SalesData as LegacySalesData } from "../../stores/manufacturer/Manufacturer";

interface IProps {
  fiscalYearMonthStart?: number;
  salesData?: LegacySalesData | ApiSalesData;
  isQualified?: boolean;
}

const StatDisplay: React.FC<{ title: string; value?: number; subTitle?: string }> = ({ title, subTitle, value }) => (
  <div className="space-y-2 text-center">
    <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
      {title}
      {subTitle ? ` (${subTitle})` : null}
    </p>
    <p className="text-3xl font-semibold tracking-tight text-slate-900">
      <FormattedNumber value={value || 0} />
    </p>
  </div>
);

const SalesSummary: React.FC<IProps> = ({ salesData: rawSalesData, fiscalYearMonthStart, isQualified }) => {
  const isLegacy = (sd: LegacySalesData | ApiSalesData | undefined): sd is LegacySalesData => !!sd && "salesLast30Days" in sd;

  const salesData: ApiSalesData | undefined = isLegacy(rawSalesData)
    ? {
      SalesLast30Days: rawSalesData.salesLast30Days,
      SalesLast3Months: rawSalesData.salesLast3Months,
      SalesYearToDay: rawSalesData.salesYearToDay,
    }
    : rawSalesData;

  return (
    <Card
      className={[
        "overflow-hidden rounded-2xl bg-white shadow-sm",
        isQualified ? "border-2 border-[var(--ops-accent)]" : "border border-gray-100",
      ].join(" ")}
    >
      <div className="flex flex-col divide-y divide-gray-100 md:flex-row md:divide-x md:divide-y-0" title="Sales">
        {(fiscalYearMonthStart || 0) > 0 && (
          <div className="flex flex-1 items-center justify-center p-6">
            <StatDisplay title="Year to Day" subTitle={LongMonthName(fiscalYearMonthStart)} value={salesData?.SalesYearToDay} />
          </div>
        )}
        <div className="flex flex-1 items-center justify-center p-6">
          <StatDisplay title="Last 3 Months" value={salesData?.SalesLast3Months} />
        </div>
        <div className="flex flex-1 items-center justify-center p-6">
          <StatDisplay title="Last 30 days" value={salesData?.SalesLast30Days} />
        </div>
        <div className="flex flex-1 items-center justify-center p-6">
          <SalesTrendingIcon salesData={salesData} fontSize="large" />
        </div>
      </div>
    </Card>
  );
}

export default SalesSummary;
